module.exports = __webpack_public_path__ + "static/img/bg2.bc79615.jpg";